/**
 * HELP-ARTICLE-HTML.UTILS
 * The body of a help article is HTML written in Strapi : sanitized before being displayed
 */
import DOMPurify from "dompurify"

//Links open in a new tab, without access to the application
//The links to another guide (#guide-<key>) stay in the window
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && !(node.getAttribute("href") ?? "").startsWith("#guide-")) {
    node.setAttribute("target", "_blank")
    node.setAttribute("rel", "noopener noreferrer")
  }
})

export function sanitizeHelpHtml(html: string): string {
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true }, ADD_ATTR: ["target"] })
}
